import axiosTuri from "../../axiosTuri";

// Get All Day Tours
export const getAllDayTours = async (id) => {
  const res = await axiosTuri.get(`get-all-daytours/${id}`);
  if (res.data.status == "success") {
    return res.data;
  }
};

// Create Day Tour
export const createDayTour = async (data) => {
  const res = await axiosTuri.post(`create-daytour`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  if (res.data.status == "success") {
    return res.data;
  }
};

// add Day Tour Photos
export const addDayTourPhotos = async (data) => {
  const res = await axiosTuri.post(`add-daytour-photos`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  if (res.data.status == "success") {
    return res.data;
  }
};

// Edit day Tour
export const editDayTour = async (data) => {
  const res = await axiosTuri.post(`edit-daytour/${data.id}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  if (res.data.status == "success") {
    return res.data;
  }
};
// Delete Day Tour
export const deleteDayTour = async (id) => {
  const res = await axiosTuri.delete(`delete-daytour/${id}`);
  if (res.data.status == "success") {
    return res.data;
  }
};

// Delete Day Tour
export const deleteDayTourPhoto = async (id) => {
  const res = await axiosTuri.delete(`delete-daytour-photo/${id}`);
  if (res.data.status == "success") {
    return res.data;
  }
};

// Get All Drivers
export const getAllDrivers = async (id) => {
  const res = await axiosTuri.get(`get-all-drivers/${id}`);
  if (res.data.status == "success") {
    return res.data;
  }
};
// Create New Driver
export const createDriver = async (data) => {
  const res = await axiosTuri.post(`create-driver`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  if (res.data.status == "success") {
    return res.data;
  }
};
// Delete Driver
export const deleteDriver = async (id) => {
  const res = await axiosTuri.delete(`delete-driver/${id}`);
  if (res.data.status == "success") {
    return res.data;
  }
};

// Get Single Driver
export const getSingleDriver = async (id) => {
  const res = await axiosTuri.get(`get-single-driver/${id}`);
  if (res.data.status == "success") {
    return res.data;
  }
};

// Edit Driver
export const editDriver = async (data) => {
  const res = await axiosTuri.post(`edit-driver/${data.id}`, data);
  if (res.data.status == "success") {
    return res.data;
  }
};

// add Day Tour Photos
export const addDriverCarPhotos = async (data) => {
  const res = await axiosTuri.post(`add-driver-carphotos`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  if (res.data.status == "success") {
    return res.data;
  }
};

// Delete Day Tour
export const deleteDriverCarPhoto = async (id) => {
  const res = await axiosTuri.delete(`delete-driver-carphoto/${id}`);
  if (res.data.status == "success") {
    return res.data;
  }
};

// add Driver Photo
export const addDriverPhoto = async (data) => {
  const res = await axiosTuri.post(`add-driver-photo/${data.driver_id}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  if (res.data.status == "success") {
    return res.data;
  }
};

// Get All Tourguides
export const getAllTourguides = async (id) => {
  const res = await axiosTuri.get(`get-all-tourguides/${id}`);
  if (res.data.status == "success") {
    return res.data;
  }
};

// Create New Tourguide
export const createTourguide = async (data) => {
  const res = await axiosTuri.post(`create-tourguide`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  if (res.data.status == "success") {
    return res.data;
  }
};

// Delete Driver
export const deleteTourguide = async (id) => {
  const res = await axiosTuri.delete(`delete-tourguide/${id}`);
  if (res.data.status == "success") {
    return res.data;
  }
};

// Edit Driver
export const editTourguide = async (data) => {
  const res = await axiosTuri.post(`edit-tourguide/${data.id}`, data);
  if (res.data.status == "success") {
    return res.data;
  }
};

// add Tourguide Photo
export const addTourguidePhoto = async (data) => {
  const res = await axiosTuri.post(
    `add-tourguide-photo/${data.tourguide_id}`,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  if (res.data.status == "success") {
    return res.data;
  }
};

// Get All Accommodations
export const getAllAccommodations = async (id) => {
  const res = await axiosTuri.get(`get-all-accommodations/${id}`);
  if (res.data.status == "success") {
    return res.data;
  }
};

// Get Single Accommodation
export const getSingleAccommodation = async (id) => {
  const res = await axiosTuri.get(`get-single-accommodation/${id}`);
  if (res.data.status == "success") {
    return res.data;
  }
};

// Create New Accommodation
export const createAccommodation = async (data) => {
  const res = await axiosTuri.post(`create-accommodation`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  if (res.data.status == "success") {
    return res.data;
  }
};

// Delete Accommodation
export const deleteAccommodation = async (id) => {
  const res = await axiosTuri.delete(`delete-accommodation/${id}`);
  if (res.data.status == "success") {
    return res.data;
  }
};

// Edit Accommodation
export const editAccommodation = async (data) => {
  const res = await axiosTuri.post(`edit-accommodation/${data.id}`, data);
  if (res.data.status == "success") {
    return res.data;
  }
};

// Change Accommodation Featured Photo
export const addAccommodationFeaturedPhoto = async (data) => {
  const res = await axiosTuri.post(
    `add-accommodation-featuredphoto/${data.accommodation_id}`,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  if (res.data.status == "success") {
    return res.data;
  }
};

// add Accommodation Photos
export const addAccommodationPhotos = async (data) => {
  const res = await axiosTuri.post(`add-accommodation-photos`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  if (res.data.status == "success") {
    return res.data;
  }
};

// Delete Accommodation Photo
export const deleteAccommodationPhoto = async (id) => {
  const res = await axiosTuri.delete(`delete-accommodation-photo/${id}`);
  if (res.data.status == "success") {
    return res.data;
  }
};

// Edit Accommodation Share
export const editAccommodationShare = async (data) => {
  const res = await axiosTuri.post(
    `edit-accommodation-share/${data.accommodation_id}`,
    data
  );
  if (res.data.status == "success") {
    return res.data;
  }
};

// Get Rooms Categories
export const getRoomsCategories = async () => {
  const res = await axiosTuri.get(`get-rooms-categories`);
  if (res.data.status == "success") {
    return res.data;
  }
};

// update  Accommodation Rooms Categories
export const syncRoomCategories = async (data) => {
  const res = await axiosTuri.post(`syncRoomCategories`, data);
  if (res.data.status == "success") {
    return res.data;
  }
};

// updateOrCreateSeasonsAndPrices
export const updateOrCreateSeasonsAndPrices = async (data) => {
  const res = await axiosTuri.post(`updateOrCreateSeasonsAndPrices`, data);
  if (res.data.status == "success") {
    return res.data;
  }
};
